import {useTheme} from "@mui/material";
import {grey} from "@mui/material/colors";
import {css} from "@emotion/css";

// compact single-choice toggle for toolbars and ribbons
export function SegmentedToggle<T extends string>(props: {
    label?: string;
    value: T;
    options: {value: T; label: string}[];
    onChange(value: T): void;
}) {
    const theme = useTheme();
    const primary = theme.palette.primary;

    return (
        <div className={wrapperCss}>
            {props.label && <span className={labelCss}>{props.label}</span>}
            <div className={groupCss}>
                {props.options.map(o => {
                    const selected = o.value === props.value;

                    return (
                        <button
                            key={o.value}
                            type="button"
                            className={buttonCss}
                            style={selected ? {
                                backgroundColor: primary.main,
                                color: primary.contrastText,
                            } : undefined}
                            onClick={() => {
                                if(!selected) props.onChange(o.value);
                            }}
                        >
                            {o.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

const wrapperCss = css({
    display: "flex",
    alignItems: "center",
    gap: 6,
});

const labelCss = css({
    fontSize: "0.75rem",
    color: grey["700"],
});

const groupCss = css({
    display: "flex",
    border: "1px solid " + grey["400"],
    borderRadius: 4,
    overflow: "hidden",
});

const buttonCss = css({
    height: 24,
    padding: "0 10px",
    border: "none",
    borderLeft: "1px solid " + grey["400"],
    backgroundColor: "transparent",
    color: grey["800"],
    fontSize: "0.75rem",
    fontFamily: "inherit",
    cursor: "pointer",
    whiteSpace: "nowrap",

    "&:first-of-type": {
        borderLeft: "none",
    },

    "&:hover": {
        backgroundColor: grey["100"],
    },
});
